import { KeycloakConfig } from 'keycloak-js';
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.

let keycloakConfig: KeycloakConfig = {
  url: 'https://auth.ecotx.dev',
  realm: 'eco-realm',
  clientId: 'ecotx-web',
};

let powerBiConfig = {
  reportBaseURL: 'https://app.powerbi.com/reportEmbed',
  qnaBaseURL: 'https://app.powerbi.com/qnaEmbed',
  tileBaseURL: 'https://app.powerbi.com/embed',
  groupID: '3aca5f3d-d7af-4311-a3c7-89f8716479bc',
  reportID: '619c668f-9be0-4589-ae6d-3f456847eeb2',
};

export const environment = {
  legacyLayout: false,
  production: false,
  appVersion: 'ecotx-web.v1',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: false,
  apiUrl: 'https://platform-service.ecotx.dev/api',
  apiGraphqLUrl: 'https://platform-service.ecotx.dev/graphql',
  platformUrl: 'https://platform-service.ecotx.dev',
  userProfileApiUrl: 'https://user.ecotx.dev',
  mapServicesUrl: 'https://map-services.ecotx.dev',
  paymentsApiUrl: 'https://payments.ecotx.dev',
  geoSparkAppUrl: 'https://search-api.datlaz.com',
  keycloak: keycloakConfig,
  powerBi: powerBiConfig,
  eMapUrl: 'https://map.ecotx.dev',
  workspaceUrl: 'https://workspace.ecotx.dev',
  ecotxBackofficeUrl: 'https://backoffice.ecotx.dev',
  leadz3Url: 'https://leadz.datlaz.com',
  paineisUrl: 'https://paineis.datlaz.com',
  ecotxNotificationsWSS: 'wss://notifications.ecotx.dev/websocket',
  tocPdfUrl: 'https://user.ecotx.dev/DATLAZ-TOS.pdf',
  eCnpjUrl: 'https://e-cnpj.ecotx.dev/rede',
  businessHubUrl: 'https://business-hub.ecotx.dev',
  sinapseUrl: 'https://sinapse.ecotx.dev',
  lupaUrl: 'https://lupa.ecotx.dev',
  siteScoringUrl: 'https://site-scoring.ecotx.dev',
  labelingUrl: 'https://label-studio.datlaz.com',
  mediaFileUrl: 'https://geoserver.ecotx.dev/storage/media',
  mediaUrl: 'https://media-service.ecotx.dev/media',
  layerServiceDataUrl: 'https://layer-service-data.ecotx.dev',
  mapboxGlToken:
    'pk.eyJ1IjoiZWNvdHgiLCJhIjoiY2ttdmVhdHgwMDQ4bzJva3Zoc291MnByaCJ9.SloN4lYumupiPOXz8eshuA',
  hotjar: {
    enabled: false,
    siteId: 3340857,
    hotjarVersion: 6,
    debug: true,
    identify: false
  },
  analytics: {
    identify: false,
    trackLogout: false,
    trackDashboardAccess: false,
    trackLabsAppAccess: false,
  },
  postHog: {
    enabled: false,
    postHogKey: "phc_UJOk0a2B5ZkSAL2ym21P2hQeo2nmk7NxNmzqytxkiWy",
    postHogHost: "https://us.i.posthog.com",
  },
  leadsAtConfig: {
    type: "AT",
    pricePerLeadInReal: 4.0,
    layerId: "db3dcdf5-77d7-456d-8d2e-a3d8b7c6eecb",
    geometryPropertiesId: {
      city: "0c12f9cf-6780-4cd0-b74d-c39f8c6f825a",
      neighborhood: "08556a26-43a8-483d-afc9-ead6a3c28692",
      tariffGroup: "6199d23c-cda0-4c60-9717-26fb84129274",
      consumptionClass: "e53843da-bc32-497a-a0d7-1d71144faee3",
      cegGd: "68e0b063-2ce3-4d52-91df-a8bb3fff527c",
      distributor: "494ca8f8-c70a-4f15-91f8-dee504ca8e45",
      consumption: "349070aa-2f4d-414d-9a17-65e853680823",
      demand: "7ac61dec-50f9-4662-b159-89124d6bbe0e",
      freeMarket: "83dac572-375c-4de7-9cc6-5a503fa20e75",
      cnae: "4ad1f893-1207-4461-9fa2-fe0acdced9e7"
    }
  },
  leadsMtConfig: {
    type: "MT",
    pricePerLeadInReal: 4.0,
    layerId: "",
    geometryPropertiesId: {
      city: "",
      neighborhood: "",
      tariffGroup: "",
      consumptionClass: "",
      cegGd: "",
      distributor: "",
      consumption: "",
      demand: "",
      freeMarket: "",
      cnae: ""
    }
  },
  leadsBtConfig: {
    type: "BT",
    pricePerLeadInReal: 2.0,
    layerId: "",
    geometryPropertiesId: {
      city: "",
      neighborhood: "",
      tariffGroup: "",
      consumptionClass: "",
      cegGd: "",
      distributor: "",
      consumption: "",
      demand: "",
      freeMarket: "",
      cnae: ""
    }
  },
  publicMapId: "",
  labsAccess: {
    siteSelection: true,
    infoDatlaz: true,
    supplyChain: true,
    sinapse: true,
    businessHub: true,
    lupa: true,
    siteScoring: true,
    labeling: true,
    solarMonitor: true,
    solarPanelDetection: true,
    qgis: true,
    arcgis: true,
    paineis: true,
  },
  credits: {
    minPurchaseAmount: 50,
    pricePerDatlazCredit: 1,
    datlazCreditToRealRate: 1,
    creditBulkDiscount: 0.9
  }
};